export enum AppRole {
  SuperAdmin = 'SuperAdmin',
  RegionalAdmin = 'RegionalAdmin',
  Bumper = 'Bumper',
  BuilderSupervisor = 'BuilderSupervisor',
  RegionalManager = 'RegionalManager',
  Supervisor = 'Supervisor',
  MaterialDispatcher = 'MaterialDispatcher',
  LaborCoordinator = 'LaborCoordinator',
  SupplierRepresentative = 'SupplierRepresentative',
  SupplyProTester = 'SupplyProTester',
  AccountingViewOnly = 'AccountingViewOnly',
}
